import "./SignInUp.css";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";

const SignInUp = () => {
  const [isSignUp, setSignUp] = useState(false);

  return (
    <div
      className={`${isSignUp ? "signin-signup-container sign-up-mode" : "signin-signup-container"}`}
    >
      <Link to={"/"} className="pageCloseBtn">
        <FaHome />
      </Link>

      <div className="forms-container">
        <div className="signIn-signUp">
          <SignIn />
          <SignUp setSignUp={setSignUp} />
        </div>
      </div>

      <div className="panels-container">
        <div className="panel left-panel">
          <div className="content">
            <h3 className="text-white">Nie masz jeszcze u nas konta? </h3>
            <h3 className="header-title-adjust">Zarejestruj się!</h3>
            <p></p>
            <button
              className="iBtn transparent"
              onClick={() => setSignUp(true)}
            >
              ZAREJESTRUJ
            </button>
          </div>
        </div>

        <div className="panel right-panel">
          <div className="content">
            <h3 className="text-white">Masz już u nas konto? </h3>
            <h3 className="text-white">Zaloguj się!</h3>
            <p></p>
            <button
              className="iBtn transparent"
              onClick={() => setSignUp(false)}
            >
              ZALOGUJ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInUp;
